import { render, staticRenderFns } from "./GameCard.vue?vue&type=template&id=6d290066&scoped=true&"
import script from "./GameCard.vue?vue&type=script&lang=js&"
export * from "./GameCard.vue?vue&type=script&lang=js&"
import style0 from "./GameCard.vue?vue&type=style&index=0&id=6d290066&scoped=true&lang=css&"
import style1 from "./GameCard.vue?vue&type=style&index=1&id=6d290066&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d290066",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardSubtitle,VCardTitle,VCol,VImg,VRow})
